<template>
<div>
	<common-top :commonTopData="commonTopData"></common-top>
	<div v-if="commonTopData.tabnums==0" class="wh Detail myBOx">
		<ul class="myBOx2">
				<li>
					<span>提现单ID</span>
					<span>{{  getValue(detailData.apply_id)}}</span>
				</li>
				<li>
					<span>提现用户ID</span>
					<span>{{  getValue(detailData.open_id)}}</span>
				</li>
				<li>
					<span>用户昵称</span>
					<span>{{ getValue(detailData.username) }}</span>
				</li>
				<li>
					<span>提现金额</span>
					<span>{{ getValue(detailData.cash_money) }}</span>
				</li>
				<li>
					<span>账号主体</span>
					<span>{{ detailData.contributor_type == "1" ? "个人" : "企业" }}</span>
				</li>
				<li>
					<span>收款账户名</span>
					<span>{{ getValue(detailData.account_name) }}</span>
				</li>
				<li>
					<span>银行卡号</span>
					<span>{{ getValue(detailData.bank_card_id) }}</span>
				</li>
				<li>
					<span>开户银行</span>
					<span>{{ getValue(detailData.bank_name) }}</span>
				</li>
				<li>
					<span class="fleft detailKey">开户支行</span>
					<span>{{ getValue(detailData.bank_name) }}</span>
				</li>
				<li>
					<span class="fleft detailKey">银行预留手机号</span>
					<span>{{ getValue(detailData.mobile) }}</span>
				</li>
				<li>
					<span>状态</span>
					<span>{{ key(detailData.check_status) }}</span>
				</li>
				<li>
					<span>申请时间</span>
					<span>{{ getValue(detailData.apply_time) }}</span>
				</li>
				<li>
					<span>处理时间</span>
					<span>{{ getValue(detailData.check_time) }}</span>
				</li>
		</ul>
		
		<div class="screenContent detailbtn">
			<button class="defaultbtn" @click="getparent()">返回</button>
		</div>
	</div>

	<div v-else class="wh Detail myBOx">
		<ul class="myBOx2">
			<li>
				<span>发票拍照</span>
				<span class="myBOx2_xd" @click="getimgulr(detailData.invoice)" :style="backImg(detailData.invoice)"></span>
			</li>
			<li>
				<span>物流公司名称</span>
				<span>{{  getValue(detailData.express_company)}}</span>
			</li>
			<li>
				<span>寄送物流单号</span>
				<span>{{  getValue(detailData.express_id)}}</span>
			</li>
		</ul>
		<div class="screenContent detailbtn">
			<button class="defaultbtn" @click="getparent()">返回</button>
		</div>
	</div>
	<div class="maskimg screenContent" v-if="isimgurl" @click="getimgulr">
		<img :src="imgurl" alt="暂无图片">
	</div>
</div>
</template>

<script>
    import commonTop from '@/components/commonTop.vue'
	export default {
		components: {
			commonTop
		},
		data() {
			return {
				isimgurl:false,
				imgurl:'',
				detailData: '',
				pic:[],
				commonTopData: {
					"pageName": "seeembodyRecord",
					"commonleftbtn": [],					
					"commonrightbtn": [],
					"commonbottombtn":[
						
					],
					"tabTopData":[
						{
							name:"提现信息",
							accessid:"61",
						},
						{
							name:"发票信息",
							accessid:"62",
						},
						
					],
					tabnums:0,
				},
			}
		},
		methods: {
			backImg(url){
				if(!url){return}
				return 'background-image:url('+url+')';
			},
			tabsChange(n){
				this.commonTopData.tabnums = n;
			},
			getparent() {
				this.$router.go(-1)
			},
			getValue(val) {
				if (val) {
					return val
				} else {
					return "--"
				}
			},
			getimgulr(url){
				this.imgurl = url;
				this.isimgurl = !this.isimgurl
			},
			key(n){
				var child ={
					"0":"待审核",
					"1":"审核中",
					"2":"审核通过",
					"3":"已付款 ",
					"-1":"审核失败",
					"-2":"已撤回",
				}
				
				return child[n];
			}
			
		},
		created() {
			this.detailData = JSON.parse(this.$route.query.row);
		},
		mounted(){
			
		}
	}
</script>

<style>
	.Detail {
		background: white;
	}

	.detailtitle {
		padding-left: 40px;
		padding-top: 18px;
	}

	.detailContent {
		height: calc(100% - 139px);
		overflow-y: auto;
	}

	.detailContent ul {
		padding-left: 132px;
		padding-top: 64px;
	}

	.margint13 {
		margin-bottom: 13px;
	}

	.detailKey {
		width: 160px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #999999;
	}

	.detailValueImg {
		width: 68px;
		height: 68px;
		border-radius: 50%;
		background: red;
	}

	.detailKeyImg {
		line-height: 68px;
	}

	.routerLink {
		color: #FF5121;
	}

	.detailbtn {
		height: 100px;
	}

	.squareImg {
		width: 160px;
		height: 102px;
		background: red;
	}
	
	.status .el-radio{
		width: auto;
	}
	.myBOx{
		height: 89vh;
	}
	.myBOx2{
		padding: 40px;
	}
	.myBOx2>li{
		margin-bottom: 30px;
	}
	.myBOx2>li>span{
		display: inline-block;
		vertical-align: top;
		font-size: 14px;
		line-height: 20px;
		color: #1E1E1E;
	}
	.myBOx2>li>span:nth-child(1){
		width: 112px;
		text-align: right;
		margin-right: 20px;
		color: #999999;
	}
	.myBOx2>li>span.myBOx2_xd{
		width: 160px;
		height: 90px;
		border-radius: 5px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
</style>
